"use client";

import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { Button } from "ui/core/button";

export type OpenState = "all" | "less";

type Props = ComponentProps<typeof Button> & {
  open: OpenState;
};

export const ViewAllButton = ({ open, ...props }: Props) => {
  const { t } = useLang();
  const { updateQuery } = useUpdateQuery();
  return (
    <Button
      onClick={() => {
        if (open === "less") updateQuery({ name: "open", value: "all" });
        else updateQuery({ name: "open", value: "less" });
      }}
      {...props}
      variant="secondary"
      className={twMerge(
        "mx-auto mt-4 block w-full @lg:hidden",
        props.className
      )}
    >
      {open === "less"
        ? t.analysis.overview.highRelevanceTable.viewAll
        : t.analysis.overview.highRelevanceTable.viewLess}
    </Button>
  );
};
